"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _recompose = require("recompose");

var _reactRouter = require("react-router");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _SavedPaymentDetails = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/SavedPaymentDetails");

var _SavedPaymentDetails2 = _interopRequireDefault(_SavedPaymentDetails);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footer = function footer(hasBackLink) {
  return (0, _glamor.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: hasBackLink ? "space-between" : "flex-end",
    marginTop: (0, _css.unitRem)(1.5)
  });
};

var tos = (0, _glamor.css)({
  color: _css.colors.gray
});

var leftArrow = (0, _glamor.css)({
  display: "inline-block",
  width: (0, _css.unitRem)(0.625),
  height: (0, _css.unitRem)(0.625),
  border: "none",
  borderLeft: "1px solid " + _css.colors.gray,
  borderBottom: "1px solid " + _css.colors.gray,
  transform: "rotate(45deg)"
});

var backButton = (0, _glamor.css)({
  float: "left",
  color: _css.colors.gray,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  paddingTop: "1.05em",
  paddingBottom: "1.2em",
  fontWeight: 300,
  textDecoration: "none",
  fontSize: (0, _css.unitRem)(1)
});

var backButtonContent = (0, _glamor.css)({
  marginLeft: "6px",
  ":after": {
    content: '"Back"'
  }
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  ":after": {
    content: '"Back to settings"'
  }
}));

var fields = (0, _glamor.css)({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "3em"
});

var applyButton = (0, _glamor.css)({
  flexBasis: "50%",
  marginTop: (0, _css.unitRem)(1.95),
  paddingLeft: (0, _css.unitRem)(0.833)
});

var promoCodeField = (0, _glamor.css)({
  marginTop: "1.5em",
  flexBasis: "100%"
});

var promoCodeMessage = (0, _glamor.css)({
  display: "block",
  color: _css.colors.gray,
  marginTop: "0.375em"
});

// const billingDetailsAppendix = makingPayment => (
//   <Checkbox
//     disabled={makingPayment}
//     label="Subscribe to Megascans Newletter"
//   />
// )

var paymentDetailsAppendix = function paymentDetailsAppendix(props) {
  return _react2.default.createElement(
    "div",
    null,
    props.showPromoCode && _react2.default.createElement(
      "div",
      { className: fields },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        errorBelow: true,
        className: promoCodeField,
        disabled: props.makingPayment || props.isAnnualSubscription,
        label: "Promo Code",
        loading: props.validatingPromoCode,
        icon: "acquire",
        isValidResult: props.promoCodeMessage
      }, props.promoCode)),
      props.showPromoCode && props.promoCodeMessage && _react2.default.createElement(
        "span",
        { className: promoCodeMessage },
        props.promoCodeMessage
      ),
      props.isAnnualSubscription && _react2.default.createElement(
        "span",
        { className: promoCodeMessage },
        "* Promo codes do not apply to annual subscriptions"
      )
    ),
    props.renderCaptcha(props.fields.captcha),
    _react2.default.createElement(
      _Checkbox2.default,
      (0, _extends3.default)({ disabled: props.makingPayment, simpleError: true }, props.acceptTos),
      _react2.default.createElement(
        "span",
        { className: tos },
        "By completing this purchase you accept our\xA0",
        _react2.default.createElement(_TextButton2.default, {
          mode: "small-gray-underlined",
          href: "/terms",
          label: "Terms of Service",
          newWindow: true
        })
      )
    )
  );
};

var SavedPaymentDetailsCheckout = function SavedPaymentDetailsCheckout(props) {
  return _react2.default.createElement(
    _Form2.default,
    { onSubmit: props.handleSubmit, error: props.error },
    _react2.default.createElement(_SavedPaymentDetails2.default, (0, _extends3.default)({}, props, {
      paymentDetailsAppendix: paymentDetailsAppendix(props)
    })),
    _react2.default.createElement(
      "div",
      { className: footer(!!props.backLink) },
      props.backLink && _react2.default.createElement(
        _reactRouter.Link,
        {
          className: backButton,
          to: {
            pathname: props.backLink,
            state: { comingBackFromNextPage: true }
          }
        },
        _react2.default.createElement("span", { className: leftArrow }),
        _react2.default.createElement("span", { className: backButtonContent })
      ),
      _react2.default.createElement(_Button2.default, {
        type: "submit",
        mode: "secondary",
        label: "Confirm Purchase",
        disable: props.makingPayment,
        loading: props.makingPayment
      })
    )
  );
};

exports.default = (0, _recompose.lifecycle)({
  componentWillMount: function componentWillMount() {
    this.props.updatePrice(this.props.billingDetails.countryCode, this.props.billingDetails.state, this.props.billingDetails.city, this.props.billingDetails.postalCode, this.props.billingDetails.vatNo, true);
  }
})(SavedPaymentDetailsCheckout);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SavedPaymentDetailsForm/SavedPaymentDetailsCheckout.jsx
// module id = 2546
// module chunks = 0